<template>
  <div class="coupons">
    <div v-if="selectedCoupons.length">
      <h3 class="block-title my-4">{{ $t('coupon.all') }}</h3>
      <BsiCouponList :items="selectedCoupons"></BsiCouponList>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import BsiCouponList from '@/modules/cart/components/Coupons/BsiCouponList'

export default {
  name: 'BsiCoupons',
  components: {
    BsiCouponList
  },
  computed: {
    ...mapState({
      selectedCoupons: state => state.cart.selectedCoupons
    })
  }
}
</script>
